import { useQuery } from '@tanstack/react-query';

import { GET_TEAM_ANALYTICS_DASHBOARD } from '../../contracts/keys';
import { getTeamAnalyticsDashboard } from '../api/teams';

export { GET_TEAM_ANALYTICS_DASHBOARD };

export function useQueryTeamAnalyticsDashboard(
  teamId: string | undefined,
  sessionKey: string
) {
  return useQuery({
    queryKey: [GET_TEAM_ANALYTICS_DASHBOARD, { teamId, sessionKey }],
    enabled: !!teamId,
    queryFn: async () => {
      const { data } = await getTeamAnalyticsDashboard(teamId!);
      return data;
    },
    staleTime: Infinity, // Don't auto-refetch while mounted (sessionKey ensures fresh fetch on remount)
    gcTime: 0, // Clean up immediately on unmount
    refetchOnWindowFocus: false, // Don't refetch on window focus (one-time tokens shouldn't be wasted)
  });
}
